import * as api from '@sloyd/api';
import { actions, idbSaveImage, selectors } from '@sloyd/store-base';
import { delay, fork, put, select, takeEvery } from 'saga-ts';
import { getCanvasBase64, guid4, invokeEvent, l } from 'shared-base';

export const saga = {
  id: 'sloyd.transform',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['transform'],
  },
};

type Verb = 'styleTransfer'; //

const map: Record<Verb, any> = {
  styleTransfer: styleTransfer,
};

export function* styleTransfer(action: any) {
  const { payload } = action;
  const { styleTransferStyle } = payload ?? {};

  const realtimeState = yield* select(selectors.raw.$rawRealtimeState);
  const { styleTransferHideFloor } = realtimeState;

  const imageId = guid4();

  try {
    const { styleTransferStyleLabel } = payload;

    if (styleTransferHideFloor) {
      invokeEvent('TOGGLE_FLOOR', { show: false });
    }

    yield delay(100);
    const base64 = getCanvasBase64('.SceneBuilder-wrapper');
    yield delay(100);

    if (styleTransferHideFloor) {
      invokeEvent('TOGGLE_FLOOR', { show: true });
    }

    yield put(
      actions.realtimeState.patch({
        styleTransferImageId: imageId,
        isStyleTransferDialogOpen: true,
        styleTransferStyle,
      })
    );

    const res = yield api.ai.styleTransfer(styleTransferStyleLabel, base64);

    const b64_json = res.b64_json;

    if (!b64_json) {
      throw new Error('No image data returned from API');
    }

    // Save to IndexedDB
    yield idbSaveImage(imageId, b64_json);

    invokeEvent('STYLE_TRANSFER_READY', { imageId });
  } catch (err) {
    invokeEvent('STYLE_TRANSFER_ERROR', { imageId });
    console.log('err =>', err);
  }
}

export function* transform(action: any) {
  const { verb } = action;

  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.scene ${verb}`);

  yield* fork(saga, action);
}

export function* root() {
  yield takeEvery('TRANSFORM', transform);
}
